
// src/helpers/file-upload.js

import actions from '../actions'

export default function (files, dispatch, id, type, componentId, singleImage = false) {
  if (!Object.prototype.toString.call(files).match(/File/))
    return

  if (singleImage) {
    if (!files[0].type.match(/^image/))
      return
  }

  for (var i = 0; singleImage && i < 1 || !singleImage && files[i]; i ++) {
    var file = files[i]
    if (file.type && file.type.match(/^(video|audio)/)) {
      var _id = type == 'user' ? undefined : id
      dispatch(actions.uploadVideo(
        _id,
        file.name,
        file.type.match(/^video/) ? 'video' : 'audio',
        file,
        componentId
      ))
    }
    else {
      dispatch(actions.uploadFile(
        id,
        type,
        file,
        componentId,
        singleImage
      ))
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/file-upload.js